(function () {
    'use strict';

    angular
        .module('cacmRoutes', [
            'cacmModule',
            'cacmEventRoutes'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'searchV2ServiceProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, searchV2ServiceProvider, historyCtxtServiceProvider) {
        $stateProvider

            .state('cacm', {
                url: '/CACM?' + searchV2ServiceProvider.getSearchUrlStateParams(),
                params: searchV2ServiceProvider.getSearchStateParamsConfig(),
                reloadOnSearch: false,
                views: {
                    '': {
                        template: '<div ui-view="mainContent"></div>'
                    },
                    'mainContent@cacm': {
                        templateUrl: require('./cacm.tpl.html'),
                        controller: 'CacmController'
                    }
                }
            });

        historyCtxtServiceProvider.setCtxtState('cacm',
                '/app/Main/search/GOVHistoryCtxtDirective-searchResults.tpl.html');
    }
})();